import { render, staticRenderFns } from "./ActNewOld.vue?vue&type=template&id=736adec0&scoped=true"
import script from "./ActNewOld.vue?vue&type=script&lang=js"
export * from "./ActNewOld.vue?vue&type=script&lang=js"
import style0 from "./ActNewOld.vue?vue&type=style&index=0&id=736adec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736adec0",
  null
  
)

export default component.exports